import React from "react";
import { Link } from "react-router-dom";

import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db, firebase } from "firebase/fbConfig.js"
import moment from "moment"

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import CakeIcon from '@material-ui/icons/Cake';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ProfilePicUpload from "components/CustomUpload/profilePicUpload"
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/profileStyle";
import { Grid } from "@material-ui/core";

// Forms
import ProfileForm from "components/Forms/profileForm.jsx"
import JobApplicationForm from "components/Forms/JobApplicationForm.jsx"

// Assets
import DefaultProfile from "assets/img/default-avatar.png"

// Firebase Redux Integration
import { tableToFirestoreObjects, updateFirestoreWithOneObject, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetActionsList, startToggleCompleted, setUserScore } from "store/actions/actionsActions"

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      updateProfileModal: false,
      updatePhotoModal: false,
      entitiyDataLoaded: false,
      userDataLoaded: false,
      entitiyColumns: [
        {
          Header: "DETAILS",
          accessor: "id",
          Cell: ({ value }) => (<Link to={`/vendor/${value}`}><button>Details</button></Link>),
          sortable: false,
          filterable: false
        },
        {
          Header: "NAME",
          accessor: "name"
        },
        {
          Header: "TYPE",
          accessor: "type"
        }
      ],

    };
  }

  handleClickOpen = (modal) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
    });
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  loadData = () => {
    this.setState({
      dataLoaded: true
    })
  }

  loadVendorsData = (id) => {
    console.log("loading vendor data")
    let data = db.collection("TEST-vendors").doc(id)
      .get().then((snapshot) => {
        var docData = snapshot.data()
        if (docData) {
          var docObj = {
            id: snapshot.id,
            name: docData.name ? docData.name : "N/A",
            physicalAddress: docData.physicalAddress ? docData.physicalAddress : "N/A",
            accountingNotes: docData.accountingNotes ? docData.accountingNotes : "N/A",
            creditCardInterface: docData.creditCardInterface ? docData.creditCardInterface : "N/A",
            dotNumber: docData.dotNumber ? docData.dotNumber : "N/A",
            dpo: docData.dpo ? docData.dpo : "N/A",
            insuranceinformation: docData.insuranceinformation ? docData.insuranceinformation : "N/A",
            locationNotes: docData.locationNotes ? docData.locationNotes : "N/A",
            mailingAddress: docData.mailingAddress ? docData.mailingAddress : "N/A",
            mainPhone: docData.mainPhone ? docData.mainPhone : "N/A",
            mcmxffNumber: docData.mcmxffNumber ? docData.mcmxffNumber : "N/A",
            remit: docData.remit ? docData.remit : "N/A",
            vendorType: docData.vendorType ? docData.vendorType : "N/A",
          }
          return (docObj)
        } else {
          return (null)
        }
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(docObj => {
        this.setState({
          data: docObj,
          dataLoaded: true
        })
      })
    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }


  loadUserData = (id) => {
    let data = db.collection("TEST-users").doc(id)
    .get().then((snapshot) => {
      var docData = snapshot.data()
      if (docData) {
        var docObj = {
          ...docData,
          id: snapshot.id,
        }
        return (docObj)
      } else {
        return (null)
      }
    }, (error) => {
        console.log('error fetching data: ', error)
      }).then(docObj => {
        this.setState({
          userData: docObj,
          userDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }


  loadEntitiesData = (id) => {
    let data = db.collection("TEST-users").doc(id).collection("entities")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        this.setState({
          entitiyData: data,
          entitiyDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }


  render() {
    const { AuthBool, classes, authUser, user, id } = this.props;

    let profilePhoto = DefaultProfile
    if (AuthBool) { // fixes freeze on logout
      if (user.dataLoaded) {
        user.profileURL ? (
          profilePhoto = user.profileURL
        ) : (
            // add link to profile photo to firestore
            profilePhoto = !!this.props.authUser.photoURL ? this.props.authUser.photoURL : DefaultProfile
            // add profile photo to firebase storage        
            // update redux with link
          )
      }
    }

    if (user.dataLoaded && AuthBool
      && !this.state.dataLoaded) {
      //console.log(id)
      this.loadData();
      this.loadEntitiesData(id)
    }
    if (!this.state.userDataLoaded) {
      this.loadUserData(id);
    }

    if (this.state.userDataLoaded) {
      //console.log(this.state.userData)
    }
    //console.log(user)
    //console.log(this.state)
    return (

      <GridContainer justify="center" >
        <GridItem xs={12} sm={12} md={10} >
          {this.state.dataLoaded && this.state.userDataLoaded ? (
            <div>
              <GridContainer style={{ backgroundImage: "url(https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/backgrounds%2Fcargorx.gif?alt=media&token=93c41d0a-eef8-4678-990f-7641ac77c938)", backgroundSize: "cover", padding: "20px 0px 0px 0px", marginTop: "-50px", width: "132%", marginLeft: "-16%" }}>
                <GridItem xs={4} sm={2} md={2} >
                  <div onClick={() => this.handleClickOpen("updatePhotoModal")}>
                    <img
                      className={classes.profilePic}
                      src={this.state.userData.profileURL ? this.state.userData.profileURL : DefaultProfile}
                      style={{marginLeft: "30%", marginTop: "10px", marginBottom: "-30px", border: "5px solid white", boxShadow: "0px 0px 5px 0px #888888" }}
                      alt="User Photo"
                    />
                  </div>
                </GridItem>
              </GridContainer>
              <GridContainer style={{ marginTop: "25px" }}>
                <GridItem xs={7}>
                  <h3 className={classes.body}><b>{this.state.userData.firstName ? this.state.userData.firstName : "N/A"}{" "}{this.state.userData.lastName ? this.state.userData.lastName : "N/A"}</b></h3>
                </GridItem>
                <GridItem xs={4}>
                  <GridContainer>
                    <GridItem xs={4}>
                      {this.state.userData.facebookLink ? <a href={"https://www.facebook.com/"+this.state.userData.facebookLink} target="_blank"> <FacebookIcon style={{ color: "#3b5998", fontSize: "32px" }} /> </a> : null}
                    </GridItem>
                    <GridItem xs={4}>
                      {this.state.userData.instagramLink ? <a href={"https://www.instagram.com/"+this.state.userData.instagramLink} target="_blank"> <InstagramIcon style={{ backgroundImage: "linear-gradient(45deg, #fdd600, #fa780c, #d11d56, #7e33b3)", color: "#fff", borderRadius: "8px", fontSize: "32px" }} /> </a> : null}
                    </GridItem>
                    <GridItem xs={4}>
                      {this.state.userData.linkedInLink ? <a href={"https://www.linkedin.com/in/"+this.state.userData.linkedInLink} target="_blank"> <LinkedInIcon style={{ color: "#0072b1", fontSize: "32px" }} /> </a> : null}
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={5}>
                  {this.state.userData.title ? <p className={classes.body}>{this.state.userData.title}</p> : <p className={classes.body}>Add job title</p>}
                </GridItem>
                <GridItem xs={7}>
                  {this.state.userData.sta ? <p className={classes.body}>STA: <b>{this.state.userData.sta}</b> </p> : <p className={classes.body}>STA: Add STA</p>}
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <p className={classes.body}><a href={"mailto:" + this.state.userData.email}><EmailIcon style={{ marginBottom: "-4px" }} fontSize="small" /> {this.state.userData.email}</a></p>
                  <p className={classes.body}>{this.state.userData.directPhone ? <span><a href={"tel:1" + this.state.userData.directPhone}><PhoneIcon style={{ marginBottom: "-4px" }} fontSize="small" /> {this.state.userData.directPhone}</a></span> : <span>add direct phone</span>} | {this.state.userData.cellPhone ? <span><a href={"tel:1" + this.state.userData.cellPhone}><PhoneAndroidIcon style={{ marginBottom: "-4px" }} fontSize="small" /> {this.state.userData.cellPhone}</a></span> : <span>add cell phone</span>}</p>
                  {this.state.userData.dob ? <p className={classes.body}><CakeIcon style={{ marginBottom: "-3px" }} fontSize="small" /> {moment(this.state.userData.dob.toDate()).format('MM-DD-YYYY')}</p> : <p className={classes.body}>Click UPDATE to add your date of birth</p>}
                </GridItem>
              </GridContainer>
              {/* <Button
                color="primary"
                onClick={() => this.handleClickOpen("updateProfileModal")}
              >
                UPDATE
              </Button> */}
              <hr></hr>
              <GridContainer>
                <GridItem xs={12}>
                  <h4 className={classes.subTitle}>ENTITY ASSOCIATION:</h4>
                  {this.state.entitiyDataLoaded ?
                    <ReactTable
                      data={this.state.entitiyData}
                      filterable
                      columns={this.state.entitiyColumns}
                      defaultPageSize={10}
                      defaultSorted={[
                        {
                        }
                      ]}
                      //showPaginationTop
                      showPaginationBottom
                      style={{
                        color: "#000"
                      }}
                      className="-striped -highlight"
                    /> : null
                  }
                  {/*
                    this.state.userData.groups.length > 0 ? (
                      this.state.userData.groups.map(group => {
                        return <p className={classes.body} key={group}>{group}</p>
                      })
                    ) : (
                        <p className={classes.body}>click UPDATE to add yourself to groups</p>
                      )
                  }
                  <h4 className={classes.subTitle}>APPROVAL CHECKS:</h4>
                  {
                    this.state.userData.termGroups.length > 0 ? (
                      this.state.userData.termGroups.map(termGroup => {
                        return <p className={classes.body} key={termGroup}>{termGroup}</p>
                      })
                    ) : (
                        <p className={classes.body}>click UPDATE to sign documents</p>
                      )
                    */}


                </GridItem>
                <GridItem xs={12}>

                  <h4 className={classes.subTitle}>PAST SHIPMENTS:</h4>
                </GridItem>

                {/* UPDATE PROFILE MODAL */}
                <Dialog
                  // classes={{
                  //   root: classes.modalRoot,
                  //   paper: classes.modal + " " + classes.modalSmall
                  // }}
                  open={this.state.updateProfileModal}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => this.handleClose("updateProfileModal")}
                  aria-labelledby="shipment-modal-slide-title"
                  aria-describedby="shipment-modal-slide-description"
                >
                  <DialogTitle
                    id="shipment-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                  >
                    <Button
                      simple
                      className={classes.modalCloseButton}
                      key="close"
                      aria-label="Close"
                      onClick={() => this.handleClose("updateProfileModal")}
                    >
                      {" "}
                      <Close className={classes.modalClose} />
                    </Button>
                    <h2 className={classes.modalTitle}>EDIT PROFILE</h2>
                  </DialogTitle>
                  <DialogContent
                    id="shipment-modal-slide-description"
                    className={classes.modalBody}
                  >
                    {/* FORM */}
                    {AuthBool ? (
                      <ProfileForm
                        user={this.props.user}
                        uid={this.props.authUser.uid}
                        modalOpen={this.state.updateProfileModal}
                      />
                    ) : null}
                    <Button
                      style={{
                        backgroundColor: "black",
                        marginLeft: "10px",
                        marginTop: "10px"
                      }}
                      key="close"
                      aria-label="Close"
                      onClick={() => this.handleClose("updateProfileModal")}
                    >
                      CLOSE
                  </Button>
                  </DialogContent>
                </Dialog>

                {/* UPDATE PROFILE PHOTO MODAL */}
                <Dialog
                  classes={{
                    root: classes.modalRoot,
                    paper: classes.modal + " " + classes.modalSmall
                  }}
                  open={this.state.updatePhotoModal}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => this.handleClose("updatePhotoModal")}
                  aria-labelledby="shipment-modal-slide-title"
                  aria-describedby="shipment-modal-slide-description"
                >
                  <DialogTitle
                    id="shipment-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                  >
                    <Button
                      simple
                      className={classes.modalCloseButton}
                      key="close"
                      aria-label="Close"
                      onClick={() => this.handleClose("updatePhotoModal")}
                    >
                      {" "}
                      <Close className={classes.modalClose} />
                    </Button>
                    <h2 className={classes.modalTitle}>UPDATE PROFILE PHOTO</h2>
                  </DialogTitle>
                  <DialogContent
                    id="shipment-modal-slide-description"
                    className={classes.modalBody}
                  >

                    {/* FORM */}
                    <ProfilePicUpload
                      currentPic={profilePhoto}
                      username={this.state.userData.username ? this.state.userData.username : null}
                      uid={this.props.authUser.uid}
                    />
                    <div
                      style={{
                        textAlign: "center"
                      }}
                    >
                      <Button
                        style={{ backgroundColor: "black" }}
                        key="close"
                        aria-label="Close"
                        onClick={() => this.handleClose("updatePhotoModal")}
                      >
                        CANCEL
                  </Button>
                    </div>
                  </DialogContent>
                </Dialog>
              </GridContainer>
            </div>
          ) : (
              <p className={classes.body}>Loading...</p>
            )}
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
    id: ownProps.match.params.id
  }
}

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUserScore: (score) => dispatch(setUserScore(score))
//   }
// }

export default compose(
  connect(mapStateToProps),
  withStyles(Style)
)(Orders);



// WEBPACK FOOTER //
// ./src/views/Profile/userProfile.jsx